//==本JS是加载Lodop插件及CLodop服务的综合示例，可直接使用，建议看懂后融进自己页面程序==


import { MessageBox,Message} from 'element-ui'

// ====页面动态加载C-Lodop云打印必须的文件CLodopfuncs.js====

var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement

var oscript = document.createElement('script')

// 让本机的浏览器打印(更优先一点)：

oscript = document.createElement('script')

oscript.src = 'http://localhost:8000/CLodopfuncs.js?priority=2'

head.insertBefore(oscript, head.firstChild)

// 加载双端口(8000和18000）避免其中某个端口被占用：

oscript = document.createElement('script')

oscript.src = 'http://localhost:18000/CLodopfuncs.js?priority=1'

head.insertBefore(oscript, head.firstChild)

// 下载loadLodop

function loadLodop() {
    // Message.error("C-Lodop尚未安装！请前往官网下载并安装");

  /* 没安装打印机时，报错的message防止和支付成功的message重叠，加message-error-defined */
  Message({
    type: 'error',
    message: 'C-Lodop尚未安装！请前往官网下载并安装',
    customClass: 'message-error-defined'
  });
  //  window.open('../../public/static/CLodop_Setup_for_Win32NT.exe')

}


// ====获取LODOP对象的主过程：====

function getLodop() {

    var LODOP

    try {

        LODOP = getCLodop()

        if (!LODOP && document.readyState !== 'complete') {

            // Message.error("C-Lodop打印控件还没准备好，请稍后再试");
          Message({
            type: 'error',
            message: 'C-Lodop尚未安装！请前往官网下载并安装',
            customClass: 'message-error-defined'
          });

            return

        }
        LODOP.SET_LICENSES("北京数字医信科技有限公司","BCF84F898EE17DECE40DD1E8A683CA08","北京數字醫信科技有限公司","A59E3518BC4D9F7B2934361E8ED23EC9");
      // 2023.10.10应坤坤说要替换密钥
      // LODOP.SET_LICENSES("北京数字医信科技有限公司","FA25BE2291884B625A9C893C177E3152454","北京數字醫信科技有限公司","FA367E1AC4331B5C403C64095521643D586");
      // LODOP.SET_LICENSES("THIRD LICENSE","","Beijing Digital Medical Information Technology Co., Ltd","C91A80D1DEA7E42FBCBFEA6FD25BACDEEBF");
        return LODOP

    } catch (err) {
        loadLodop()
        // MessageBox({

        //     title: '温馨提示',

        //     type: 'warning',

        //     showCancelButton: true,

        //     message: '您还未安装打印控件，点击确定下载打印控件，安装成功后刷新页面即可进行打印',

        //     callback: res => {

        //         if (res === 'confirm') {

        //             loadLodop()

        //         }

        //     }

        // })

    }

}

export  {getLodop}

